var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.1514H9V13.1514H7V11.1514ZM7 15.1514H9V17.1514H7V15.1514ZM11 11.1514H13V13.1514H11V11.1514ZM11 15.1514H13V17.1514H11V15.1514ZM15 11.1514H17V13.1514H15V11.1514ZM15 15.1514H17V17.1514H15V15.1514Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.17687V20.1771C3 21.1559 3.7965 21.9516 4.77525 21.9516H18.7755C19.7542 21.9516 20.55 21.1551 20.55 20.1771V6.17687C20.55 5.19812 19.7535 4.40162 18.7755 4.40162H16.5502V2.40137H15.0015V4.40162H8.55V2.40137H6.99975V4.40162H4.77525C3.7965 4.40162 3 5.19812 3 6.17687ZM19.0005 7.95137L19.0012 20.4014H4.55025V7.95137H19.0005Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCalendar);
export default __webpack_public_path__ + "static/media/icons-calendar.c3d9b4b0c8e4b5274d4d893d60c86391.svg";
export { ForwardRef as ReactComponent };